"use client"

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import Link from "next/link"

const faqs = [
  {
    question: "What are design credits?",
    answer:
      "Design credits are the currency used whenever you perform an AI action in the app. Different actions may use different amounts of credits — for example, generating new room designs from your photo will cost more credits than generating designs from scratch. To keep things transparent, each action button clearly shows the number of credits it will use before you proceed. Monthly subscribers get 250 credits per month and we also offer pay-as-you-go credit packs.",
  },
  {
    question: "Do credits expire?",
    answer:
      "No! Unused monthly subscription credits will rollover and accumulate as long as you have an active subscription. Purchased credit packs do not expire.",
  },
  {
    question: "Can I cancel my subscription?",
    answer:
      "Yes, you can cancel your subscription at any time from your account settings. You'll continue to have access to your plan features until the end of your current billing period. Unused credits from monthly will rollover and accumulate.",
  },
  {
    question: "Are there any refunds?",
    answer: null, // Converting to JSX component for proper link handling
    component: (
      <span>
        We do not offer refunds, but you can cancel your monthly membership at any time. If you're unhappy with your
        results, we're here to help! You can visit our{" "}
        <Link href="/support" className="text-[#40A1AB] hover:text-[#3A919A] underline">
          Support Page
        </Link>{" "}
        to check out our FAQs, submit a support request, or email us directly at support@roomvia.ai.
      </span>
    ),
  },
]

export function FAQSection() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold mb-4">Frequently Asked Questions</h2>
      </div>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left font-medium">{faq.question}</AccordionTrigger>
            <AccordionContent className="text-gray-600">{faq.component || faq.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
